import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { BehaviorSubject, Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { AuthService } from "src/app/core/service/auth.service";
import { SubscriptionService } from "src/app/core/service/subscription.service";
import { GetDataDTO } from "src/app/data/schema/Common/GetDataDTO";
import { UserCertificateDTO } from "src/app/data/schema/UserCourse/userCertificate/UserCertificateDTO";
import { UserCertificateQueryParamsDTO } from "src/app/data/schema/UserCourse/userCertificate/UserCertificateQueryParamsDTO";
import { ApiCoursesService } from "src/app/data/service/courses/api-courses.service";
import { ApiUserCertificatesService } from "src/app/data/service/userCourses/api-user-certificates.service";
import { CertificateViewerComponent } from "src/app/shared/component/certificate-viewer/certificate-viewer.component";

@Component({
    selector: "app-profile-certificates",
    templateUrl: "./profile-certificates.component.html",
    styleUrls: ["./profile-certificates.component.scss"]
})
export class ProfileCertificatesComponent implements OnInit, OnDestroy {
    page = 0;
    pageSize = 100;
    unsubscribeAll: Subject<any>;
    datas: GetDataDTO<UserCertificateDTO>;
    data: BehaviorSubject<UserCertificateDTO[]>;

    constructor(
        private subscriptionService: SubscriptionService,
        private authService: AuthService,
        private dialog: MatDialog,
        private spinner: NgxSpinnerService,
        private certificatesService: ApiUserCertificatesService,
        private courseService: ApiCoursesService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.unsubscribeAll = new Subject();
        this.datas = {
            data: [],
            totalRows: 0
        };

        this.data = new BehaviorSubject<UserCertificateDTO[]>([]);
        this.route.queryParams.subscribe((res) => {
            if (res.openCourseId) this.openByCourse(res.openCourseId);
        });
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.complete();
        this.unsubscribeAll.unsubscribe();
    }

    ngOnInit(): void {
        this.loadCertificates();
    }

    loadCertificates(): void {
        this.spinner.show();
        this.certificatesService
            .list({
                fillCourse: true,
                skip: this.page * this.pageSize,
                take: this.pageSize,
                subscriptionId: this.subscriptionService.currentSubscription.id,
                userId: this.authService.getClaimsUserId()
            })
            .pipe(
                finalize(() => this.spinner.hide()),
                takeUntil(this.unsubscribeAll)
            )
            .subscribe((res) => {
                this.datas.data.push(...res.data);
                this.datas.totalRows = res.totalRows;
                this.data.next(this.datas.data);
            });
    }

    loadMore(): void {
        this.page += 1;
        this.loadCertificates();
    }

    open(id: string): void {
        const cfg: MatDialogConfig<UserCertificateQueryParamsDTO> = {
            data: {
                skip: 0,
                take: 1,
                subscriptionId: this.subscriptionService.currentSubscription?.id,
                id: id,
                userId: this.authService.getClaimsUserId(),
                fillCourse: true
            },
            maxHeight: "99dvh",
            maxWidth: "99vw"
        };
        this.dialog.open(CertificateViewerComponent, cfg);
    }

    openByCourse(id: string): void {
        const cfg: MatDialogConfig<UserCertificateQueryParamsDTO> = {
            data: {
                skip: 0,
                take: 1,
                subscriptionId: this.subscriptionService.currentSubscription?.id,
                courseId: id,
                userId: this.authService.getClaimsUserId(),
                fillCourse: true
            },
            maxHeight: "99dvh",
            maxWidth: "99vw"
        };
        this.dialog
            .open(CertificateViewerComponent, cfg)
            .afterClosed()
            .subscribe(() => {
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: {}
                });
            });
    }
}
